import { Card } from '@mui/material';
import MuiLink from '@mui/material/Link';

/**
 * Read-only task submission view.
 *
 * @param {Object} props
 * @param {Object} props.submission
 * @param {number} props.version Revision index (r0, r1, r2...)
 * @param {boolean} [props.canAddRevision=false] Whether to show "Add revision" action
 * @param {Function} [props.onAddRevision] Callback fired when "Add revision" is clicked
 */
export default function TaskSubmissionView({
  submission,
  version,
  canAddRevision = false,
  onAddRevision = () => {},
}: { submission: any; version: any; canAddRevision?: boolean; onAddRevision?: any }) {
  const { documentUrl, documentName, comment, status, createdAt } = submission || {};

  return (
    <Card {...{ borderVariant: 'default', colorVariant: 'primary' } as any}>
      <div className='column gap-1'>
        <span className='font-md'>r{version}</span>

        {documentUrl ? (
          <MuiLink
            href={documentUrl}
            target='_blank'
            rel='noopener noreferrer'
            sx={{ textDecoration: 'underline' }}
          >
            {documentName || 'View file'}
          </MuiLink>
        ) : (
          <span className='text-sm'>No file attached</span>
        )}

        <span>{comment || '-'}</span>

        {createdAt && <span className='text-xs'>{createdAt}</span>}

        {canAddRevision && typeof onAddRevision === 'function' && (
          <button type='button' onClick={onAddRevision} className='btn cta-outlined-btn self-start'>
            Add revision
          </button>
        )}
      </div>
    </Card>
  );
}
